export class GrupoEconomicoRequest{
    idUsuario: number;
    idCliente: number;
    cnpjCliente: string;
    iECli: string;
    descGrupo: string;
}
